import { Host,Element,Event,EventEmitter,Component, Prop, h } from '@stencil/core';
import { isBrowser } from '../../constants/constants';
import { trackAnalyticsEvent } from '../../utils/analytics';

@Component({
  tag: 'ci-navigation',
  styleUrl: 'ci-navigation.scss',
  assetsDirs: ['../assets'],
  shadow: true,
})
export class ciNavigation {
  @Element() $el: HTMLElement;
  @Prop({ mutable: true }) ciHeaderMainClass: string;
  @Event() openOverlay: EventEmitter<void>;
  @Event() closeOverlay: EventEmitter<void>;

  // Declare the properties here
  private showOverlayTimeout: number;
  private hideOverlayTimeout: number;

  render() {
    const handleShowOverlay = event => {
      clearTimeout(this.hideOverlayTimeout);

      const target = event.currentTarget;
      if (!target) return;

      this.showOverlayTimeout = window.setTimeout(() => {
        const activePanels = this.$el.shadowRoot.querySelectorAll('.active');
        activePanels.forEach(activePanel => {
          activePanel.classList.remove('active');
        });

        const panel = this.$el.shadowRoot.querySelector(target.id);
        if (!panel) return;

        this.openOverlay.emit();
        panel.classList.add('active');
      }, 200);
    };

    const handleHideOverlay = () => {
      clearTimeout(this.showOverlayTimeout);
      this.hideOverlayTimeout = window.setTimeout(() => {
        const activePanels = this.$el.shadowRoot.querySelectorAll('.active');

        this.closeOverlay.emit();
        activePanels.forEach(activePanel => {
          activePanel.classList.remove('active');
        });
      }, 200);
    };

    return (
      <Host>
        <div class="ciHeader-subNav-item " id="ci-custom-t-shirts" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
          <a
            href={`${process.env.CI_HOSTNAME}/products/t-shirts/4`}
            class="ciHeader-subNav-link"
            onClick={trackAnalyticsEvent}
            data-section="custom tshirts"
            data-link="custom tshirts"
          >
            <span class="ciHeader-subNav-text">
              Custom T-shirts
            </span>
          </a>
          {isBrowser && <ci-custom-t-shirts id="tShirtsProductOverlay" class="ciHeader-subNav-panel"></ci-custom-t-shirts>}
        </div>
        <div class="ciHeader-subNav-item " id="ci-apparel" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
          <a
            href={`${process.env.CI_HOSTNAME}/products/apparel/857`}
            class="ciHeader-subNav-link"
            onClick={trackAnalyticsEvent}
            data-section="apparel"
            data-link="apparel"
          >
            <span class="ciHeader-subNav-text">
              Custom Apparel
            </span>
          </a>
          {isBrowser && <ci-apparel id="apparelProductOverlay" class="ciHeader-subNav-panel"></ci-apparel>}
        </div>
        <div class="ciHeader-subNav-item " id="ci-promo-products" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
          <a
            href={`${process.env.CI_HOSTNAME}/products/promotional-products/218`}
            class="ciHeader-subNav-link"
            onClick={trackAnalyticsEvent}
            data-section="promotional products"
            data-link="promotional products"
          >
            <span class="ciHeader-subNav-text">
              Promotional Products
            </span>
          </a>
          {isBrowser && <ci-promo-products id="promoProductOverlay" class="ciHeader-subNav-panel"></ci-promo-products>}
        </div>
        <div class="ciHeader-subNav-item" id="ci-design-lab" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
          <a
            href={`${process.env.CI_HOSTNAME}/lab`}
            class="ciHeader-subNav-link"
            onClick={trackAnalyticsEvent}
            data-section="design lab"
            data-link="design lab"
          >
            <span class="ciHeader-subNav-text">
              Design Lab
            </span>
          </a>
          {isBrowser && <ci-design-lab id="designOverlay" class="ciHeader-subNav-panel"></ci-design-lab>}
        </div>
        <div class="ciHeader-subNav-item" id="ci-solutions" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
          <span class="ciHeader-subNav-link">
            <span
              class="ciHeader-subNav-text"
              onClick={trackAnalyticsEvent}
              data-section="solutions"
              data-link="solutions"
            >
              Solutions
            </span>
          </span>
          {isBrowser && <ci-solutions id="solutionsOverlay" class="ciHeader-subNav-panel"></ci-solutions>}
        </div>
      </Host>
    );
  }
}
